export const REDUCER_NAME = "teamSponsors";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_TEAMSPONSORS = `${REDUCER_NAME}/SET_TEAMSPONSORS`;
export const RESET_TEAMSPONSORS = `${REDUCER_NAME}/RESET_TEAMSPONSORS`;
